export { default } from './DashboardMenu';
